const STORAGE_KEY = 'ld.connectionsFilter.sections'

export type FilterSectionKey = 'actions' | 'contactInfo' | 'work' | 'tagsNotes'

export type FilterSectionsState = Record<FilterSectionKey, boolean>

export const DEFAULT_FILTER_SECTIONS: FilterSectionsState = {
    actions: true,
    contactInfo: true,
    work: true,
    tagsNotes: true,
}

const isBoolean = (value: unknown): value is boolean => typeof value === 'boolean'

export const getFilterSectionsState = (): FilterSectionsState => {
    try {
        const raw = localStorage.getItem(STORAGE_KEY)
        if (!raw) return { ...DEFAULT_FILTER_SECTIONS }

        const parsed = JSON.parse(raw)
        return {
            actions: isBoolean(parsed?.actions) ? parsed.actions : DEFAULT_FILTER_SECTIONS.actions,
            contactInfo: isBoolean(parsed?.contactInfo) ? parsed.contactInfo : DEFAULT_FILTER_SECTIONS.contactInfo,
            work: isBoolean(parsed?.work) ? parsed.work : DEFAULT_FILTER_SECTIONS.work,
            tagsNotes: isBoolean(parsed?.tagsNotes) ? parsed.tagsNotes : DEFAULT_FILTER_SECTIONS.tagsNotes,
        }
    } catch {
        return { ...DEFAULT_FILTER_SECTIONS }
    }
}

export const setFilterSectionsState = (state: FilterSectionsState): void => {
    try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(state))
    } catch {
        // ignore quota / private mode errors
    }
}
